import React, {ReactNode} from 'react'
import FacilitiesRepository from '../../../facilities/FacilitiesRepository'
import {Nullable} from '../../../../app/TypeHelpers'
import { Box, Card, DialogActions, DialogContent, DialogTitle, CardMedia } from '@mui/material';
import {FACILITY_CATEGORY,} from '../../../../CodeMaster'
import {LeftRowFlexContainer,} from '../../../../styledComponents/FlexComponents'
import styled from 'styled-components'
import {getFacilityCategoryImageUrl} from '../../../facilities/FacilityCategoryImageHelper'
import {AdminDefaultButton} from '../../../../styledComponents/adminPage/Buttons'
import EventEmitterExAdmin from '../../../shared/pageBaseComponents/EventEmitterExAdmin'
import {AsyncCommunicationProps} from '../../../shared/hoc/withAsyncCommunication'
import {LoggerProps} from '../../../shared/hoc/withLogger'
import {AdminPageHeadingArea} from '../../../shared/pageBaseComponents/AdminPageHeadingArea'
import {Colors} from '../../../../styledComponents/Constants'
import FacilityInfoDetails from '../../../facilities/FacilityInfoDetails'
import {ImageLocation} from '../../../facilities/FacilityDetails'

interface Props {
    condominiumCd: string
    facilityId: number
    facilitiesRepo: FacilitiesRepository
    eventEmitter: EventEmitterExAdmin
    onClose: () => void
}

interface State {
    facility: Nullable<FacilityInfoDetails>
}

export default class ARFacilityInfoDetailsComponent
    extends React.Component<Props & AsyncCommunicationProps & LoggerProps, State> {

    static displayName: string = 'ARFacilityInfoDetailsComponent'

    constructor(props: Readonly<Props & AsyncCommunicationProps & LoggerProps>) {
        super(props)
        this.state = {
            facility: null,
        }
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const {facilitiesRepo, condominiumCd, facilityId} = this.props

            const facility: Nullable<FacilityInfoDetails> = await this.props.asyncCallFunction(
                facilitiesRepo.getFacilityInfoDetails.bind(facilitiesRepo, condominiumCd, facilityId),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (facility) {
                document.title = `施設情報 − ${facility.facilityName}`
                this.setState({
                    facility: facility,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    renderImageCard(images: ImageLocation[], category: FACILITY_CATEGORY): ReactNode {
        if (images.length === 0) {
            return <Card>
                <StyledCardContent>
                    <CardMedia
                        style={{maxWidth: '200px', maxHeight: '200px'}}
                        component={'img'}
                        src={getFacilityCategoryImageUrl(category)}
                    />
                </StyledCardContent>
            </Card>
        }

        return (<>{
            images.map((image, index) => {
                return (
                    <Box
                        ml={(index !== 0) ? '10px' : undefined}
                        key={index}
                    >
                        <Card>
                            <StyledCardContent>
                                <CardMedia
                                    style={{maxWidth: '200px', maxHeight: '200px'}}
                                    component={'img'}
                                    src={image.url}
                                />
                            </StyledCardContent>
                        </Card>
                    </Box>
                )
            })
        }</>)
    }

    render(): ReactNode {
        const {facility} = this.state
        if (facility === null) {
            return null
        }

        return (<>
            <StyledDialogTitle>
                <AdminPageHeadingArea
                    title={'施設情報詳細'}
                />
            </StyledDialogTitle>
            <StyledDialogContent>
                <div>
                    {facility.facilityName}
                </div>
                <Box mt={'15px'}>
                    <LeftRowFlexContainer>
                        {this.renderImageCard(facility.images, facility.category)}
                    </LeftRowFlexContainer>
                </Box>
                {
                    facility.facilityIntroductory &&
                    <FacilityIntroductory dangerouslySetInnerHTML={{__html: facility.facilityIntroductory}}/>
                }
            </StyledDialogContent>
            <StyledDialogActions>
                <AdminDefaultButton onClick={() => this.props.onClose()}>
                    閉じる
                </AdminDefaultButton>
            </StyledDialogActions>
        </>)
    }
}

const StyledDialogTitle = styled(DialogTitle)`
  padding-bottom: 0!important;
  padding-left: 12px!important;
  padding-right: 12px!important;
`

const StyledDialogContent = styled(DialogContent)`
  padding-left: 12px!important;
  padding-right: 12px!important;
`

const StyledCardContent = styled.div`
  background-color: #EEEEEE;
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledDialogActions = styled(DialogActions)`
  justify-content: center!important;
  padding: 12px!important;
`

const FacilityIntroductory = styled.div`
  margin: 15px 0;
  padding: 0 15px;
  border: solid 1px ${Colors.AccentLight};
  border-radius: 4px;
  word-break: break-all;
`
